import PopupBase from './PopupBase';
import { useEffect, useMemo, useState } from 'react';
import UserApi from '../api/UserApi';
import { getUserInfo } from '../common/cookie';

const UserRegisterPop = ({ close, userData }) => {
    const loginUser = useMemo(() => getUserInfo(), []);
    const userType = loginUser?.userType || loginUser?.USER_TYPE;
    const isAdmin = !!loginUser?.isAdmin || userType === '001';
    const isSubAdmin = !!loginUser?.isSubAdmin || userType === '011';

    const [form, setForm] = useState(userData ||{
        USER_ID: '',
        USER_PW: '',
        USER_TYPE: '002',
        USER_MEMO: '',
        USER_ORG: ''
    });

    useEffect(() => {
        // 서브관리자는 하위 유저만 생성 가능: USER_TYPE=002 고정 + USER_P_ID 자동 세팅
        if (!userData && isSubAdmin) {
            setForm(prev => ({
                ...prev,
                USER_TYPE: '002',
                USER_P_ID: loginUser?.userId || loginUser?.USER_ID || ''
            }));
        }
    }, [isSubAdmin, loginUser, userData]);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    }

    const handleConfirm = () => {
        if (userData) {
            UserApi.updateUser(userData.USER_ID, form).then(rslt => {
                console.log(rslt);
                close(true);
            });
        } else {
            UserApi.createUser(form).then(rslt => {
                console.log(rslt);
                close(true);
            });
        }
    }

    return (
        <PopupBase title="사용자 등록" confirmText={userData ? '수정' : '등록'} cancelText="취소" confirm={handleConfirm} close={close}>    
            <div className="modal-body">
                <div className="form-field">
                    <label className="field-lable">아이디</label>
                    <div className="field-input">
                        <span className="field-required">*</span>
                        <input type="text" name="USER_ID" readOnly={!!userData} placeholder="아이디를 입력해주세요." required="" value={form.USER_ID} onChange={handleChange} />
                    </div>      
                </div>
                <div className="form-field">
                    <label className="field-lable">비밀번호</label>
                    <div className="field-input">
                        <span className="field-required">*</span>
                        <input type="text" name="USER_PW" placeholder="비밀번호를 입력해주세요." required="" value={form.USER_PW} onChange={handleChange} />
                    </div>      
                </div>  
                <div className="form-field">
                    <label className="field-lable">권한</label>
                    <div className="field-input">
                        <span className="field-required">*</span>
                        {isAdmin && !userData ? (
                            <select name="USER_TYPE" value={form.USER_TYPE} onChange={handleChange}>
                                <option value="002">일반</option>
                                <option value="011">총판관리자</option>
                            </select>
                        ) : (
                            <input
                                type="text"
                                name="USER_TYPE"
                                placeholder="권한을 입력해주세요."
                                readOnly
                                value={form.USER_TYPE === '011' ? '총판관리자' : '일반'}
                            />
                        )}
                    </div>          
                </div>
                <div className="form-field">
                    <label className="field-lable">회사명</label>
                    <div className="field-input">
                        <input type="text" name="USER_ORG" placeholder="회사명을 입력해주세요." value={form.USER_ORG} onChange={handleChange} />
                    </div>      
                </div>
                <div className="form-field">
                    <label className="field-lable">메모</label>
                    <div className="field-input">
                        <textarea name="USER_MEMO" placeholder="메모를 입력해주세요." value={form.USER_MEMO}  onChange={handleChange}></textarea>
                    </div>
                </div>
            </div>
        </PopupBase>
    )
}

export default UserRegisterPop;